// test1546
(1546 && 0);
